import { fetchWithAuth } from './fetchWithAuth'

export async function deleteVenue(
  token: string,
  id: string,
): Promise<void> {
  await fetchWithAuth(`/v1/venues/${id}`, token, {
    method: 'DELETE',
  })
}
